// extracted by mini-css-extract-plugin
export var compactFilters = "_c9-4";
export var detailImage = "_c9-1";
export var dropdownContainer = "_c9-2";
export var imageContainer = "_c9-0";
export var selectedCard = "_c9-3";